import { ShareButtonComponent } from './share-button.component'

export class ShareButtonStore {
    private buttons: ShareButtonComponent[] = []

    private static _instance: ShareButtonStore
    public static getInstance(): ShareButtonStore {
        return this._instance || (this._instance = new this())
    }

    public add(button: ShareButtonComponent): void {
        this.buttons.push(button)
    }

    public close(): void {
        this.buttons.forEach((button: ShareButtonComponent) => {
            button.closeModal()
        })
    }
}
